import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type DomainNotFoundUnderPullzoneErrorOptions = {
  bunnyZoneProvider: ObjectId;
};

export class DomainNotFoundUnderPullzoneError extends FleekError<DomainNotFoundUnderPullzoneErrorOptions> {
  public name = 'DomainNotFoundUnderPullzoneError';

  toString = () => {
    return 'Domain zone not found.';
  };
}
